import moment from "moment";
import { CMContent, CMMentionsCarousel, CMSelect } from "./auction-mentions.styles";
import data, { lastDigit } from "../../images";
import { useState, useMemo, useEffect } from "react";

const AuctionMentions = ({auction,trackOptions}) => {
    //const { mentions } = auction || {};
    const [selectedTrack, setSelectedTrack] = useState(0);
    const [messageFail, setMessageFail] = useState("This song has no Mentions");
    let tracks = auction?.tracks ? auction?.tracks : [];
    const [news, setNews] = useState(tracks[selectedTrack]?.in_the_news);
    const parseJSON = () => {
        try {
            return news ? JSON.parse(news) : null;
        } catch (error) {
            console.error("Error parsing 'in_the_news' data:", error);
            setMessageFail("The information in the news is erroneous, verify your information.");
            return null;
        }
    }
    const [newsJson, setNewsJson] = useState(null);
    const [mentions, setMentions] = useState(null);

    useEffect (()=>{
        setNews(tracks[selectedTrack]?.in_the_news)
    },[selectedTrack])

    useEffect (()=>{
        setNewsJson(parseJSON())
    },[news])

    useEffect(()=>{
        setMentions(newsJson?.obj)
    },[newsJson])
    
    const handleSelectChange = (e) => {
        setSelectedTrack(e.target.value);  
    };
    if (trackOptions.length === 0 || !mentions || !mentions?.length > 0 ) return null;
    return (
        <CMContent>
            <h3>In the News</h3>
            {/*<Image src={URLImages.urlNews} className="CMImageSize" />*/}
            {trackOptions?.length > 0 ?(
            <>
                    {trackOptions.length !== 1 && (
                        <CMSelect
                            value={selectedTrack}
                            onChange={handleSelectChange}
                        >
                            <option value="" disabled>Select a track</option>
                            {trackOptions.map((option, index) => (
                                 option.new && (
                                    <option key={index} value={option.value}>
                                    {option.label}
                                </option>
                                )
                            ))}
                        </CMSelect>
                    )}
                    {mentions && mentions.length > 0 &&
                        <CMMentionsCarousel>
                            {mentions && mentions.length > 0 &&
                                mentions.map((mention, index) => {
                                    return (
                                        <div key={index}>
                                            <div className="mention-thumbnail">
                                                <img src={mention.image_url} />
                                            </div>
                                            <div className="mention-content">
                                                <span className="date">{moment(mention.date).format('MMM DD, YYYY')}</span>
                                                <div className="description">
                                                    {mention.source} - <a href={mention.url} title={mention.title} target="_blank">{mention.title}</a>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </CMMentionsCarousel>
                    }
            {!mentions && 
                <h5>{messageFail}</h5>
                }
            </>
            ):(
                <p style={{marginTop:"30px"}}>No Tracks</p>
            )}
        
        </CMContent>
    );
}

export default AuctionMentions;